import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Button, Typography } from '@mui/material';
import InitiativeColumn from './initiative.column';
import { useNavigate } from 'react-router-dom';
import { getAllInitiative } from './initiative.service';
import { Icon } from "@iconify/react";
import Loader from '../../../components/loader';
import GenericDataGrid from '../../../components/genericTable';
import { createManagementTableSx } from '../../../styles/tableStyles';
import { managementCreateButtonSx, managementHeaderActionSx, managementHeaderContentSx, managementHeaderSx, managementPageSubtitleSx, managementPageTitleSx } from '../../../styles/managementStyles';
import { buttonContentSx } from '../../../styles/dialogStyles';
import NotificationSnackbar from '../../../components/notificationSnackbar';
import InlineAlert from '../../../components/inlineAlert';

export default function Initiative() {

  const navigate = useNavigate();
  const [initiativeData, setInitiativeData] = useState([]);
  const [errors, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [currenntPagemain, setCurrentPagemain] = useState(0);
  const [rowsperpagemain, setrowsperpagemain] = useState(10);
  const [alert, setAlert] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');
  const [expandedRows, setExpandedRows] = useState(new Set());

  const alertClose = () => {
    setAlert('');
    setOpenAlert(false);
  };

  useEffect(() => {
    getInitiativeData(currenntPagemain, rowsperpagemain);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const transformInitiativeData = (initiatives) => {
    return initiatives.map((initiative) => ({
      ...initiative,
      countryName: (Array.isArray(initiative.adminData?.countries) && initiative.adminData.countries.length > 0
        ? initiative.adminData.countries.map((c) => c.name).join(', ')
        : initiative.creatorData?.country) || '-',
      status: initiative.isActive ? 'ACTIVE' : 'INACTIVE',
    }));
  };

  const getInitiativeData = async (page = currenntPagemain, size = rowsperpagemain) => {
    setLoading(true);
    await getAllInitiative(page, size).then(response => {
      setLoading(false);
      const transformedData = transformInitiativeData(response.data.content);
      setInitiativeData(transformedData);
      setTotalDataCount(response.data.totalElements);
    }).catch(error => {
      setLoading(false);
      setInitiativeData([]);
      setError('Unable to fetch data!');
    });
  };

  let salesData = {
    'limit': '',
    'page': '',
    'navigate': navigate,
    'getInitiativeData': getInitiativeData,
    'setAlert': setAlert,
    'setOpenAlert': setOpenAlert,
    'setResponseMsg': setResponseMsg,
    'setLoading': setLoading,
    'expandedRows': expandedRows,
    'onToggleDescription': (row) => {
      setExpandedRows((prev) => {
        const next = new Set(prev);
        if (next.has(row.id)) {
          next.delete(row.id);
        } else {
          next.add(row.id);
        }
        return next;
      });
    },
  }
  const subscriptionnData = InitiativeColumn(salesData);
  const displayRows = initiativeData.flatMap((row) => {
    const htmlString = row.description || '';
    const plainText = htmlString.replace(/<[^>]+>/g, '').replace(/\n/g, ' ');
    if (!expandedRows.has(row.id)) {
      return [row];
    }

    return [
      row,
      {
        id: `${row.id}-detail`,
        __detail: true,
        parentId: row.id,
        fullDescription: plainText,
      },
    ];
  });

  const initiativeGridSx = createManagementTableSx({
    extraSx: {
      '& .MuiDataGrid-row.detail-row': {
        minHeight: '60px !important',
        maxHeight: 'none !important',
      },
      '& .MuiDataGrid-row.detail-row .MuiDataGrid-cell': {
        borderTop: 'none !important',
        borderBottom: '1px solid #DFE5F6',
        alignItems: 'flex-start',
        py: 0,
        px: 0,
        backgroundColor: '#FFFFFF',
      },
      '& .MuiDataGrid-row.detail-row .MuiDataGrid-cell[data-field="name"]': {
        width: '100% !important',
        maxWidth: 'none !important',
      },
      '& .MuiDataGrid-row.detail-row .MuiDataGrid-cellContent': {
        width: '100%',
      },
      '& .MuiDataGrid-row.expanded-parent .MuiDataGrid-cell': {
        borderBottom: 'none',
      },
      '& .MuiDataGrid-row.expanded-parent': {
        borderBottom: 'none',
      },
    },
  });

  return (
    <>

      <Box sx={managementHeaderSx}>
        <Box sx={managementHeaderContentSx}>
          <Typography className="app-page-title" sx={managementPageTitleSx}>
            Initiative Management
          </Typography>
          <Typography sx={managementPageSubtitleSx}>
            Manage initiative project related to solutions.
          </Typography>
        </Box>
        <Box sx={managementHeaderActionSx}>
          <Button
            variant="contained"
            type="submit"
            onClick={() => { setLoading(true); navigate('/addInitiative') }}
            sx={{ ...managementCreateButtonSx, width: { xs: '100%', md: 'auto' }, minWidth: { xs: '100%', md: 224 } }}
          >
            <Box component="span" sx={buttonContentSx}>
              <Icon icon="tabler:plus" width="18" height="18" />
              <span>CREATE INITIATIVE</span>
            </Box>
          </Button>
        </Box>
      </Box>

      <InlineAlert
        message={openAlert && alert === 'false' ? responseMsg : ''}
        onClose={alertClose}
        variant="error"
      />

      <Box sx={{ width: '100%', padding: '0 0px' }}>
        <GenericDataGrid rows={displayRows} columns={subscriptionnData} rowCount={totalDataCount} page={currenntPagemain} pageSize={rowsperpagemain} loading={loading} errors={errors} checkbox='false'
          dataGridSx={initiativeGridSx}
          tableMinWidth={1100}
          rowHeight={60}
          getRowHeight={({ model }) => model.__detail ? 'auto' : 60}
          getRowClassName={(params) => {
            if (params.row.__detail) return 'detail-row';
            if (expandedRows.has(params.row.id)) return 'expanded-parent';
            return '';
          }}
          onPaginationChange={(page, pageSize) => {
            setCurrentPagemain(page);
            setrowsperpagemain(pageSize);
            setExpandedRows(new Set());
            getInitiativeData(page, pageSize);
          }}
        />
      </Box>
      {loading && <Loader />}

      <NotificationSnackbar
        open={openAlert && alert === 'true'}
        onClose={alertClose}
        message={responseMsg}
        severity="success"
        contentSx={{ px: 2.5 }}
      />
    </>
  );
}
